
import { Component, Vue } from 'vue-property-decorator'
import { getWhiteNoticeB, getWhiteActivationTip } from '@/api/iousServices'
@Component({
  name: 'whitePayPopup'
})
export default class whitePayPopup extends Vue {
  showResult = false

  whiteNoticeTipList: Array<{
    dataName: string
  }> = []

  created() {
    }

  showPopup() {
    this.getWhiteActivationTip()
    this.showResult = true
  }

  getWhiteActivationTip() {
    getWhiteActivationTip().then((res) => {
      this.whiteNoticeTipList = res.data
    })
  }
  handleClick() {
    this.showResult = false
  }
}
